import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-792c0a42")

_pushScopeId("data-v-792c0a42")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("News")
const _hoisted_2 = { class: "df-col fill" }
const _hoisted_3 = { class: "p-16" }
const _hoisted_4 = { class: "f-bold f-lg mb-16" }
const _hoisted_5 = { class: "df-between df-middle" }
const _hoisted_6 = {
  key: 0,
  class: "f-sm mt-16 df-middle"
}
const _hoisted_7 = { class: "px-16 advice-line pb-16" }
const _hoisted_8 = { class: "px-8 flex-1" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_t = _resolveComponent("t")
  const _component_Pic = _resolveComponent("Pic")
  const _component_Time = _resolveComponent("Time")
  const _component_router_link = _resolveComponent("router-link")
  const _component_Line = _resolveComponent("Line")
  const _component_PageWithHeader = _resolveComponent("PageWithHeader")

  return (_openBlock(), _createBlock(_component_PageWithHeader, null, {
    title: _withId(() => [
      _createVNode(_component_t, { path: "news_2" }, {
        default: _withId(() => [
          _hoisted_1
        ]),
        _: 1
      })
    ]),
    default: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode("p", _hoisted_4, _toDisplayString(_ctx.detail.articleTitle), 1),
          _createVNode("div", _hoisted_5, [
            _createVNode("div", null, [
              (_ctx.detail.authorUrl)
                ? (_openBlock(), _createBlock(_component_Pic, {
                    key: 0,
                    src: _ctx.detail.authorUrl,
                    height: "16"
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_Time, {
              class: "t-right c-tip f-sm",
              format: "MM-dd-yy HH:mm:ss",
              time: _ctx.detail.createTime
            }, null, 8, ["time"])
          ]),
          (_ctx.products && _ctx.products.length)
            ? (_openBlock(), _createBlock("div", _hoisted_6, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.products, (item) => {
                  return (_openBlock(), _createBlock(_component_router_link, {
                    key: item,
                    to: `/symbol/${item.trim()}`,
                    class: "btn sm round mr-16 px-6",
                    style: {"height":"20px","line-height":"20px"}
                  }, {
                    default: _withId(() => [
                      _createTextVNode(_toDisplayString(item), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode(_component_Line)
        ]),
        _createVNode("div", _hoisted_8, [
          _createVNode("iframe", {
            class: "frame",
            src: _ctx.detail.articleUrl
          }, null, 8, ["src"])
        ])
      ])
    ]),
    _: 1
  }))
})